import React, { useState } from 'react';
import Select, { components } from 'react-select';
import styled from 'styled-components';
import _ from 'lodash';
import { Popup } from '../common';
import { _objectIsEqual, useDeepEffect } from '../../utils/helper';
const Option = (props) => {
  let isNested = !!props.data.group;
  let isSelected = !!props.isSelected;
  const groupKey = props.innerProps.id.split('-')[4];
  const { groupExpand } = props.selectProps;
  if (isNested) {
    isSelected = false;
    let optionIndex = 0;
    for (
      optionIndex;
      optionIndex < props.selectProps.nestedOptionValue.length;
      optionIndex++
    ) {
      const option = props.selectProps.nestedOptionValue[optionIndex];
      if (_objectIsEqual(option, props.data)) {
        isSelected = true;
        break;
      }
    }
  }
  const onChangeHandler = () => {
    if (isNested) {
      props.selectProps.onNestedOptionChange(props.data.value);
      const groupOption = props.data.group;
      const groupOptionData = props.selectProps.options.find(
        (option) => option.label === groupOption,
      );
      // Find selected nested options
      const selectedNestedOption = _.filter(
        props.selectProps.nestedOptionValue,
        (option) => {
          return option.group === groupOption;
        },
      );
      const currentGroupValueIndex = _.findIndex(
        props.selectProps.value,
        (currentValue) => {
          return _objectIsEqual(currentValue, groupOptionData);
        },
      );
      if (currentGroupValueIndex === -1 && isSelected === false) {
        props.selectOption(groupOptionData);
      }
      // Unselect the last nested value, unselect the group option too
      else if (selectedNestedOption.length === 1 && isSelected === true) {
        let tempValue = [...props.selectProps.value];
        const { onChange } = props.selectProps;
        tempValue.splice(currentGroupValueIndex, 1);
        onChange(tempValue);
      }
    } else {
      props.selectOption(props.data);
    }
  };

  return (
    (Object.keys(groupExpand).length === 0 || groupExpand[groupKey]) && (
      <components.Option
        {...props}
        innerProps={{ ...props.innerProps, onClick: () => onChangeHandler() }}>
        <OptionWrapper isNested={isNested}>
          <input
            type="checkbox"
            onChange={() => onChangeHandler()}
            checked={isSelected}
          />
          <div>{props.children}</div>
        </OptionWrapper>
      </components.Option>
    )
  );
};
const GroupHeading = (props) => {
  const children = props.children.split('|');
  const label = children[0];
  const value = children[1]; const key = props.id.split('-')[4];
  const { onChange, onNestedOptionChange, groupExpand, setGroupExpand } =
    props.selectProps;
  const _onSelectGroup = () => {
    let tempValue = [...props.selectProps.value];
    // Select nested options
    const currentNestedOption = _.find(props.selectProps.options, (option) => {
      return option.label === props.children;
    });
    const nestedOptionsValue = currentNestedOption.options.map(
      (option) => option.value,
    );
    if (_valueIsSelectedIndex() === -1) {
      tempValue.push(currentNestedOption);
      onNestedOptionChange(nestedOptionsValue);
    } else {
      tempValue.splice(_valueIsSelectedIndex(), 1);
      onNestedOptionChange(nestedOptionsValue, true);
    }
    onChange(tempValue);
  };

  const _valueIsSelectedIndex = () => {
    return _.findIndex(props.selectProps.value, (currentValue) => {
      return String(currentValue.value) === String(value);
    });
  };
  const _valueIsSelected = () => {
    let selectedCount = 0;
    const { nestedOptionValue } = props.selectProps; const currentNestedOption = _.find(props.selectProps.options, (option) => {
      return option.label === props.children;
    });
    currentNestedOption.options.forEach((option) => {
      if (
        _.findIndex(nestedOptionValue, (currentOption) =>
          _objectIsEqual(currentOption, option),
        ) !== -1
      ) {
        selectedCount++;
      }
    });

    if (selectedCount === currentNestedOption.options.length) {
      return true;
    }
    return false;
  };
  return (
    <components.Option
      {...props}
    //innerProps={{...props.innerProps, onClick: () => _onSelectGroup()}}
    >
      <OptionWrapper>
        <div
          onClick={() =>
            setGroupExpand({
              ...groupExpand,
              [key]: !groupExpand[key],
            })
          }>
          <img
            src={
              groupExpand[key]
                ? require('./../../images/icon-triangle-down.png')
                : require('./../../images/icon-triangle-right.png')
            }
            width="8px"
            height="8px"
            style={{ marginRight: '10px' }}
          />
        </div>
        <input
          type="checkbox"
          onChange={() => _onSelectGroup()}
          checked={!!_valueIsSelected()}
        />
        <div>{label}</div>
      </OptionWrapper>
    </components.Option>
  );
};

const MultiValueLabel = (props) => {
  let children = props.children;
  if (props.children.split('|').length > 1) {
    children = props.children.split('|')[0];    // Finding subfield label
    let currentSelectedGroupOptionsLength = 0;
    let foundCurrentSelectedGroupOption = [];

    props.selectProps.options.forEach((option) => {
      if (option.label === props.children) {
        currentSelectedGroupOptionsLength = option.options.length;
        option.options.forEach((currentOption) => {
          const isFound = _.findIndex(
            props.selectProps.nestedOptionValue,
            (optionValue) => {
              return _objectIsEqual(optionValue, currentOption);
            },
          );
          if (isFound !== -1) {
            foundCurrentSelectedGroupOption.push(currentOption);
          }
        });
        return;
      }
    }); if (
      foundCurrentSelectedGroupOption.length > 0 &&
      currentSelectedGroupOptionsLength !==
      foundCurrentSelectedGroupOption.length
    ) {
      let subLabel = '';
      foundCurrentSelectedGroupOption.forEach(
        (option, index) => (subLabel += (index > 0 ? ', ' : '') + option.label),
      );

      children += ` (${subLabel})`;
    }
  }
  return <components.MultiValueLabel {...props} children={children} />;
};
const SelectGroup = React.forwardRef((props, ref) => {
  const [groupExpand, setGroupExpand] = useState({});
  const [inputValue, setInputValue] = useState('');
  useDeepEffect(() => {
    if (props.options.length > 0 && props.nestedOptionValue) {
      let tempValue = {};
      props.options.forEach((option, index) => {
        tempValue[index] = false;
      });
      setGroupExpand(tempValue);
    }
  }, [props.options]);
  const _handleChange = (option, meta) => {
    setInputValue('');
    if (_.isArray(option)) {
      let selectedOption = [];
      option.forEach((selected) => selectedOption.push(selected.value));
      props.onChange(selectedOption);
      if (
        props.nestedOptionValue &&
        meta !== undefined &&
        meta.action === 'remove-value'
      ) {
        const removedValue = meta.removedValue;
        const nestedSelectedValue = _.filter(
          props.nestedOptionValue,
          (option) => {
            return option.group === removedValue.label;
          },
        );
        if (nestedSelectedValue) {
          const tempValue = nestedSelectedValue.map((option) => option.value);
          props.onNestedOptionChange(tempValue, true);
        }
      }
    } else if (option !== null) {
      props.onChange(option.value);
    } else if (option === null && props.isMulti) {
      props.onChange([]);
      if (
        props.nestedOptionValue &&
        meta !== undefined &&
        meta.action === 'remove-value'
      ) {
        const removedValue = meta.removedValue;
        const nestedSelectedValue = _.filter(
          props.nestedOptionValue,
          (option) => {
            return option.group === removedValue.label;
          },
        );
        if (nestedSelectedValue) {
          const tempValue = nestedSelectedValue.map((option) => option.value);
          props.onNestedOptionChange(tempValue, true);
        }
      }
    } else {
      props.onChange('');
    }
  };
  return (
    <SelectGroupWrapper
      ref={ref}
      direction={props.direction}
      labelWidth={props.labelWidth}
      className={props.className}
      onClick={props.onClick}>
      <label>
        {props.label}
        {props.information && (
          <Popup
            trigger={() => (
              <img
                className="icon-tooltip"
                alt=""
                src={require('./../../images/icon-tooltip.png')}
              />
            )}
            position={
              props.direction === 'column' ? 'right center' : 'top center'
            }
            on={['hover']}
            closeOnDocumentClick>
            <span>{props.information}</span>
          </Popup>
        )}
      </label>
      <StyledSelect
        isDisabled={props.isDisabled}
        {...props}
        closeMenuOnSelect={false}
        components={{
          Option,
          GroupHeading,
          MultiValueLabel,
        }}
        placeholder=""
        styles={{
          container: (base) => ({
            ...base,
            border: 'none',
            outline: 'none',
          }),
          option: (base) => ({
            ...base,
            backgroundColor: '#fff',
            color: 'black',
            ':selected': {
              ...base[':active'],
              backgroundColor: '#fff',
            },
          }),
          indicatorSeparator: (base) => ({
            ...base,
            width: '0px',
          }),
          multiValue: (base) => ({
            ...base,
            backgroundColor: '#4e8ba8',
            padding: '4px 4px',
          }),
          multiValueLabel: (base) => ({
            ...base,
            fontSize: '11px',
            fontWeight: 600,
            color: '#fff',
          }),
          multiValueRemove: (base) => ({
            ...base,
            color: '#fff',
            ':hover': {
              backgroundColor: '#a9bdc8',
            },
          }),
        }}
        onChange={(option, meta) => _handleChange(option, meta)}
        groupExpand={groupExpand}
        setGroupExpand={setGroupExpand}
        onInputChange={(value, action) => {
          if (action.action === 'input-change') {
            setInputValue(value);
          }
        }}
        inputValue={inputValue}
      />
    </SelectGroupWrapper>
  );
});
const SelectGroupWrapper = styled.div`
  display: flex;
  flex-direction: ${(props) => (props.direction ? props.direction : 'row')};
  margin-bottom: 10px;
  label {
    width: ${(props) => (props.labelWidth ? props.labelWidth : `240px`)};
    text-align: left;
    padding-right: 10px;
    font-size: 12px;
    color: #2c495f;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .icon-tooltip {
      width: 18px;
      height: 18px;
      margin-left: 10px;
    }
  }
  &.flex-1 {
    flex: 1;
    margin-left: 10px;
  }
`;
const OptionWrapper = styled.div`
  display: flex;
  align-items: center;
  input[type='checkbox'] {
    margin: 0px;
  }
  div {
    margin-left: 10px;
  }
  margin-left: ${(props) => (props.isNested ? '40px' : '0px')};
`;
const StyledSelect = styled(Select)`
  max-width: calc(
    100% -
      ${(props) =>
    props.labelWidth
      ? props.labelWidth === '100%'
        ? `0px`
        : props.labelWidth
      : `240px`}
  );
  flex-grow: 1;
`;
export default SelectGroup;
